import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Sync = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Sync' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M5,19 L16,19 C19.866,19 23,15.866 23,12 L23,9 M8,15 L4,19 L8,23 M19,5 L8,5 C4.134,5 1,8.134 1,12 L1,15 M16,1 L20,5 L16,9' />
  </StyledIcon>
);
